import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({
    name: "not-found",
})
export default class NotFound extends Vue {

}
